import { LazyImage } from 'components'

import css from './Figure.module.css'

export default function Figure({ caption, imageUrl, imageAlt }) {
    return (
        <figure className={css.figure}>
            <LazyImage lazyload={false} src={imageUrl} alt={imageAlt} />
            <figcaption>{caption}</figcaption>
        </figure>
    )
}
